import { Tracking as BaseTracking } from '@folklore/tracking';

class Tracking extends BaseTracking {
    push(...args) {
        super.push(...args);
        if (typeof window.dataLayerContest !== 'undefined') {
            window.dataLayerContest.push(...args);
        }
    }

    setUser(user) {
        this.push({
            userId: user !== null ? user.id : null,
            user_id: user !== null ? user.id : null,
            user,
        });
    }

    trackPageView(page) {
        this.push({
            event: 'pageview',
            page,
        });
    }

    trackInteraction(name, data) {
        this.push({
            event: 'interaction',
            interactionName: name,
            ...data,
        });
    }

    trackAnswerQuestion(question, choice, data) {
        this.trackInteraction('question_answered', {
            question,
            choice,
            ...data,
        });
    }
}

export default Tracking;
